const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export function buildImageUrl(path) {
    if (!path || typeof path !== "string") return "";
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    return `${API_BASE_URL}${path}`;
}

export function getSpotPreviewPhoto(spot) {
    if (!spot) return "";
    return (
        spot.mainPhoto
        || spot.placePhotos?.[0]
        || spot.photos?.[0]
        || spot.photo
        || spot.image
        || spot.place?.image
        || ""
    );
}

export function spotTitle(spot) {
    if (!spot) return "";
    const title = spot.title || spot.name;
    if (title && String(title).trim()) return String(title).trim();
    return "";
}

export function spotName(spot) {
    const title = spotTitle(spot);
    if (title) return title;
    return spot?.place?.name || (spot?.id ? `Точка #${spot.id}` : "Точка");
}

export function placeName(spot) {
    return spot?.place?.name || spot?.placeName || "";
}

export function getCommentSpotPhoto(comment) {
    const spotPhoto = comment?.spot?.mainPhoto;
    if (spotPhoto) return spotPhoto;
    return comment?.placePhotos?.[0] || comment?.catchPhotos?.[0] || "";
}

export function getSuggestionPhoto(item) {
    return item?.mainPhoto || "";
}
